import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import CreditNoteDetail from "@/components/invoices/credits/credit-note-detail";

export const Route = createFileRoute(
  "/_authenticated/invoices/credit-notes/$creditNoteId/",
)({
  component: CreditNoteDetailPage,
});

function CreditNoteDetailPage() {
  const { creditNoteId } = Route.useParams();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "credit_notes", actions: ["read"] }]}
    >
      <CreditNoteDetail creditNoteId={creditNoteId} />
    </RouteGuardPermissions>
  );
}
